module.exports = __webpack_public_path__ + "img/Discrupt.0cd2ebac.svg";